import * as React from "react";

import "./pricing-modal.scss";

import {ComponentLink, Link, makeChain} from "@Common/react/cst2"
import {ModalService3}                  from "@Common/ui-components/modal-service-3/modal-service-3"

import {ModalLayout}    from "@Xpresso/routes/common/modal-layout/modal-layout";
import {RangePriceTier} from "../pricing-ranges";

export const VariationsPricingTableModal = ({next: rootNext, priceRangeTiers}:{
    next: ComponentLink<typeof ModalService3<any>, "rootNext">,
    priceRangeTiers: RangePriceTier[],
}) => (
    makeChain<JSX.Element>()
    .then(({}, next:ComponentLink<typeof ModalService3<any>>) => (
        ModalService3({
            rootNext,
            next,
        })
    ))
    .then(({}, next:Link<JSX.Element>) => (
        ModalLayout({
            title: "Pricing",
            content: next(),
        })
    ))
    .then(() => (
        <div className="variations-pricing-table-modal-d6c665">
            <em xd-qa-type="label" xd-qa-name="Title">Prices are in USD and may vary depending on your selections.</em>
            <table>
                <thead><tr>
                    <th xd-qa-type="label" xd-qa-name="Quantity">Quantity</th>
                    <th xd-qa-type="label" xd-qa-name="Price">Price</th>
                </tr></thead>
                <tbody>
                    {priceRangeTiers.map((priceRangeTier, index) => (
                        <tr key={index} xd-qa-type="card" xd-qa-name={"Row " + index}>
                            <td xd-qa-type="text" xd-qa-name={priceRangeTier.isFlatRate
                                ? priceRangeTier.min
                                : `${priceRangeTier.min} - ${priceRangeTier.max}`}
                            >{
                                priceRangeTier.isFlatRate
                                ? priceRangeTier.min
                                : `${priceRangeTier.min} - ${priceRangeTier.max}`
                            }</td>
                            <td xd-qa-type="text" xd-qa-name={getPriceValue(priceRangeTier)}>
                                {getPriceValue(priceRangeTier)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    ))
    .run()
);

const getPriceValue = (priceRangeTier) => {
    const priceDisplay = priceRangeTier.priceMin === priceRangeTier.priceMax
        ? `$${priceRangeTier.priceMin}`
        : `$${priceRangeTier.priceMin} - $${priceRangeTier.priceMax}`;

    const rateType = priceRangeTier.isFlatRate ? "flat" : "per unit";
    const tdValue = `${priceDisplay} ${rateType}`;

    return tdValue;
}